/**
 * SPRINT V3 — Reciprocal Invite.
 * When a user arrives via ?ref=<code>, we remember the inviter token so
 * after their first meaningful action we can prompt them to invite
 * someone back (closing the viral loop). Pure client state, no PII.
 */
const INVITER_KEY = "ss2026_v3_inviter_token";
const PROMPTED_KEY = "ss2026_v3_reciprocal_prompted";

export function captureInviterFromUrl(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const url = new URL(window.location.href);
    const ref = url.searchParams.get("ref");
    if (!ref) return localStorage.getItem(INVITER_KEY);
    if (!/^[A-Z0-9]{4,32}$/.test(ref)) return null;
    localStorage.setItem(INVITER_KEY, ref);
    return ref;
  } catch { return null; }
}

export function getInviterToken(): string | null {
  if (typeof window === "undefined") return null;
  try { return localStorage.getItem(INVITER_KEY); } catch { return null; }
}

export function shouldPromptReciprocal(): boolean {
  if (typeof window === "undefined") return false;
  const inviter = getInviterToken();
  if (!inviter) return false;
  try { return localStorage.getItem(PROMPTED_KEY) !== "1"; } catch { return false; }
}

export function markReciprocalPrompted() {
  if (typeof window === "undefined") return;
  try { localStorage.setItem(PROMPTED_KEY, "1"); } catch { /* noop */ }
}
